import React, {useContext, useEffect} from 'react';
import { LeReacteurContext } from 'src/components/Layout';
import Cookies from 'js-cookie';
/* --- import Components ----*/
import { Paragraph, TitleDescription } from 'src/components/Typography';
import SocialMedia from 'src/components/LandingPage/SocialMedia';
import { StyledExternalLink } from './elements';
/* --- import Styles ----*/
import colors from 'src/style/colors';
import { useMediaQueries } from 'src/utils/MediaQueries';

const FinalBlockLanding = ({ selectedEvent }) => {
  const mqs = useMediaQueries();
  const { dtlFormValidation } = useContext(LeReacteurContext);
  const calendarURL = Cookies.get('meeting_calendar_link');
  useEffect(() => {
    dtlFormValidation('landing_reunion_information');
  }, []);

  return (
    <>
      <div
        css={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
        }}
      >
        <TitleDescription css={{ color: colors.purpleVeryDark }}>Merci&nbsp;!</TitleDescription>
        <Paragraph css={{ textAlign: 'center', paddingBottom: 0 }}>
          Votre inscription à la prochaine réunion d’information du Reacteur
          {selectedEvent && selectedEvent.date && `, le ${selectedEvent.date},`} a bien été prise en
          compte. Vous allez recevoir, par mail, un récapitulatif ainsi que le lien Zoom pour vous
          connecter le jour J. <br></br>
          <br></br>Nous avons hâte de vous retrouver (virtuellement&nbsp;!) et de répondre à toutes
          vos questions. En attendant, n’hésitez pas à parcourir notre site Web ainsi que nos
          différents réseaux sociaux.
          <br></br> <br></br>
        </Paragraph>
        {calendarURL && (
          <StyledExternalLink href={calendarURL} target="_blank" rel="noopener noreferrer">
            <svg xmlns="http://www.w3.org/2000/svg" width={mqs.phoneOnly ? '55' : '40'} height="35">
              <g fill="none" fillRule="evenodd">
                <path
                  d="M3 9H21M7 3V5M17 3V5M6 12H8M11 12H13M16 12H18M6 15H8M11 15H13M16 15H18M6 18H8M11 18H13M16 18H18M6.2 21H17.8C18.9201 21 19.4802 21 19.908 20.782C20.2843 20.5903 20.5903 20.2843 20.782 19.908C21 19.4802 21 18.9201 21 17.8V8.2C21 7.07989 21 6.51984 20.782 6.09202C20.5903 5.71569 20.2843 5.40973 19.908 5.21799C19.4802 5 18.9201 5 17.8 5H6.2C5.0799 5 4.51984 5 4.09202 5.21799C3.71569 5.40973 3.40973 5.71569 3.21799 6.09202C3 6.51984 3 7.07989 3 8.2V17.8C3 18.9201 3 19.4802 3.21799 19.908C3.40973 20.2843 3.71569 20.5903 4.09202 20.782C4.51984 21 5.07989 21 6.2 21Z"
                  stroke={colors.white}
                  strokeWidth="0.7"
                  strokeLinecap="round"
                  transform={mqs.phoneOnly ? 'scale(1.3) translate(0 0)' : 'scale(1.3)'}
                />
              </g>
            </svg>
            {'   '}
            Ajouter l’événement
            {mqs.phoneOnly ? <br></br> : ' '}à mon agenda
          </StyledExternalLink>
        )}
        <Paragraph>
          À très bientôt 👋​
          <br></br> <strong>Xavier Colombel</strong>
          <br></br>
          CEO - Le Reacteur
        </Paragraph>
        <SocialMedia />
      </div>
    </>
  );
};

export default FinalBlockLanding;
